<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <v-simple-table>
      <thead>
        <tr>
          <th rowspan="2">Sede</th>
          <th rowspan="2">Cant. Prog.</th>
          <th rowspan="2">Programas</th>
          <th rowspan="2">Tipo</th>
          <th rowspan="2">Área</th>
          <th colspan="7" class="text-center">Inscripciones Programa</th>
          <th rowspan="2">Inscrip. No Cumplen Req.</th>
          <th rowspan="2">Inscrip. Cumplen Req.</th>
          <th rowspan="2">Total Inscrip. No Cumplen Req.</th>
          <th rowspan="2">Total Inscrip. Cumplen Req.</th>
        </tr>

        <tr>
          <th>Preinscritos</th>
          <th>Inscritos</th>
          <th>Retirados</th>
          <th>Cambiados</th>
          <th>Congelados</th>
          <th>Pagados</th>
          <th>Totales</th>
        </tr>
      </thead>

      <tbody>
        <tr v-if="inscripcionesPorSedes.length === 0">
          <td colspan="15" class="text-center">No hay datos disponibles</td>
        </tr>

        <template v-for="(sede, indice) in inscripcionesPorSedes">
          <tr :key="indice">
            <td :rowspan="sede.programas.length">{{ sede.nombre }}</td>
            <td class="text-right" :rowspan="sede.programas.length">{{ sede.programas.length }}</td>
            <td>{{ sede.programas[0].nombre }}</td>
            <td>{{ sede.programas[0].tipo }}</td>
            <td>{{ sede.programas[0].area }}</td>
            <td class="text-right">
              {{
                programasConInscripciones
                  .find((p) => p.id == sede.programas[0].id)
                  ?.inscripciones?.filter((p) => p.estadoInscripcion == 0).length || 0
              }}
            </td>
            <td class="text-right">
              {{
                programasConInscripciones
                  .find((p) => p.id == sede.programas[0].id)
                  ?.inscripciones?.filter((p) => p.estadoInscripcion == 1).length || 0
              }}
            </td>
            <td class="text-right">
              {{
                programasConInscripciones
                  .find((p) => p.id == sede.programas[0].id)
                  ?.inscripciones?.filter((p) => p.estadoInscripcion == 2).length || 0
              }}
            </td>
            <td class="text-right">
              {{
                programasConInscripciones
                  .find((p) => p.id == sede.programas[0].id)
                  ?.inscripciones?.filter((p) => p.estadoInscripcion == 3).length || 0
              }}
            </td>
            <td class="text-right">
              {{
                programasConInscripciones
                  .find((p) => p.id == sede.programas[0].id)
                  ?.inscripciones?.filter((p) => p.estadoInscripcion == 4).length || 0
              }}
            </td>
            <td class="text-right">
              {{
                programasConInscripciones
                  .find((p) => p.id == sede.programas[0].id)
                  ?.inscripciones?.filter((p) => p.estadoInscripcion == 5).length || 0
              }}
            </td>
            <td class="text-right">
              {{ programasConInscripciones.find((p) => p.id == sede.programas[0].id)?.inscripciones?.length || 0 }}
            </td>
            <td class="text-right">
              {{ sede.programas[0].totalInscripcionesNoCumplenRequisitos }}
            </td>
            <td class="text-right">
              {{ sede.programas[0].totalInscripcionesCumplenRequisitos }}
            </td>
            <td class="text-right" :rowspan="sede.programas.length">
              {{ sede.totalInscripcionesNoCumplenRequisitos }}
            </td>
            <td class="text-right" :rowspan="sede.programas.length">
              {{ sede.totalInscripcionesCumplenRequisitos }}
            </td>
          </tr>

          <tr v-for="programa in sede.programas.slice(1)" :key="programa.id">
            <td>{{ programa.nombre }}</td>
            <td>{{ programa.tipo }}</td>
            <td>{{ programa.area }}</td>
            <td class="text-right">
              {{
                programasConInscripciones
                  .find((p) => p.id == programa.id)
                  ?.inscripciones?.filter((p) => p.estadoInscripcion == 0).length || 0
              }}
            </td>
            <td class="text-right">
              {{
                programasConInscripciones
                  .find((p) => p.id == programa.id)
                  ?.inscripciones?.filter((p) => p.estadoInscripcion == 1).length || 0
              }}
            </td>
            <td class="text-right">
              {{
                programasConInscripciones
                  .find((p) => p.id == programa.id)
                  ?.inscripciones?.filter((p) => p.estadoInscripcion == 2).length || 0
              }}
            </td>
            <td class="text-right">
              {{
                programasConInscripciones
                  .find((p) => p.id == programa.id)
                  ?.inscripciones?.filter((p) => p.estadoInscripcion == 3).length || 0
              }}
            </td>
            <td class="text-right">
              {{
                programasConInscripciones
                  .find((p) => p.id == programa.id)
                  ?.inscripciones?.filter((p) => p.estadoInscripcion == 4).length || 0
              }}
            </td>
            <td class="text-right">
              {{
                programasConInscripciones
                  .find((p) => p.id == programa.id)
                  ?.inscripciones?.filter((p) => p.estadoInscripcion == 5).length || 0
              }}
            </td>
            <td class="text-right">
              {{ programasConInscripciones.find((p) => p.id == programa.id)?.inscripciones?.length || 0 }}
            </td>
            <td class="text-right">{{ programa.totalInscripcionesNoCumplenRequisitos }}</td>
            <td class="text-right">{{ programa.totalInscripcionesCumplenRequisitos }}</td>
          </tr>
        </template>

        <tr v-if="inscripcionesPorSedes.length > 0">
          <td><strong>TOTALES</strong></td>
          <td class="text-right">
            <strong>
              {{ inscripcionesPorSedes.reduce((total, sede) => total + sede.programas.length, 0) }}
            </strong>
          </td>
          <td class="text-right"></td>
          <td class="text-right"></td>
          <td class="text-right"></td>
          <td class="text-right">
            <strong>
              {{
                programasConInscripciones.reduce(
                  (total, prog) => total + prog.inscripciones.filter((p) => p.estadoInscripcion == 0).length,
                  0,
                )
              }}
            </strong>
          </td>
          <td class="text-right">
            <strong>
              {{
                programasConInscripciones.reduce(
                  (total, prog) => total + prog.inscripciones.filter((p) => p.estadoInscripcion == 1).length,
                  0,
                )
              }}
            </strong>
          </td>
          <td class="text-right">
            <strong>
              {{
                programasConInscripciones.reduce(
                  (total, prog) => total + prog.inscripciones.filter((p) => p.estadoInscripcion == 2).length,
                  0,
                )
              }}
            </strong>
          </td>
          <td class="text-right">
            <strong>
              {{
                programasConInscripciones.reduce(
                  (total, prog) => total + prog.inscripciones.filter((p) => p.estadoInscripcion == 3).length,
                  0,
                )
              }}
            </strong>
          </td>
          <td class="text-right">
            <strong>
              {{
                programasConInscripciones.reduce(
                  (total, prog) => total + prog.inscripciones.filter((p) => p.estadoInscripcion == 4).length,
                  0,
                )
              }}
            </strong>
          </td>
          <td class="text-right">
            <strong>
              {{
                programasConInscripciones.reduce(
                  (total, prog) => total + prog.inscripciones.filter((p) => p.estadoInscripcion == 5).length,
                  0,
                )
              }}
            </strong>
          </td>
          <td class="text-right">
            <strong>
              {{ programasConInscripciones.reduce((total, prog) => total + prog.inscripciones.length, 0) }}
            </strong>
          </td>
          <td class="text-right">
            <strong>
              {{ inscripcionesPorSedes.reduce((total, sede) => total + sede.totalInscripcionesNoCumplenRequisitos, 0) }}
            </strong>
          </td>
          <td class="text-right">
            <strong>
              {{ inscripcionesPorSedes.reduce((total, sede) => total + sede.totalInscripcionesCumplenRequisitos, 0) }}
            </strong>
          </td>
          <td class="text-right">
            <strong>
              {{ inscripcionesPorSedes.reduce((total, sede) => total + sede.totalInscripcionesNoCumplenRequisitos, 0) }}
            </strong>
          </td>
          <td class="text-right">
            <strong>
              {{ inscripcionesPorSedes.reduce((total, sede) => total + sede.totalInscripcionesCumplenRequisitos, 0) }}
            </strong>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: 'TablaInscripcionesCompletasConsolidadas',
  props: {
    inscripcionesPorSedes: {
      type: Array,
      required: true,
    },
    programasConInscripciones: {
      type: Array,
      required: true,
    },
    cargando: {
      type: Boolean,
      default: false,
    },
  },
};
</script>